import { Alert, AlertProps, Box } from '@chakra-ui/react'

interface ModalAlertIProps extends AlertProps {
  boldedText?: string
  icon: React.ReactElement
  label: string
  title: string
  color?: string
  status?: 'error' | 'warning' | 'info' | 'success'
}

export const ModalAlert = ({
  boldedText,
  label,
  icon,
  title,
  color = 'red.700',
  status = 'error',
  ...rest
}: ModalAlertIProps) => {
  return (
    <Alert
      borderRadius='lg'
      color={color}
      mb='4'
      mt='6'
      status={status}
      {...rest}
    >
      <Box flexShrink={0}>{icon}</Box>
      <Box ml='4'>
        <Box as='span' fontWeight='bold'>
          {title}
        </Box>{' '}
        {label}
        {boldedText && <Box fontWeight='bold'>{boldedText}</Box>}
      </Box>
    </Alert>
  )
}
